export default __webpack_public_path__ + "images/visitor-profile-background.97c87185c4c2df5ca76a6eea99a965a7.png";